import { AppApi } from "../../client/apis/AppApi";
import { ExpeditionApi } from "../../client/apis/ExpeditionApi";
import { ExpeditionStatusResponse } from "../../client/models/ExpeditionStatusResponse";
import { PageableShipment } from "../../client/models/PageableShipment";
import { ApiClient, Api } from "./ApiClient";

export default class ShipmentRepository {
  private static normalizePositiveInt(value: unknown, fallback: number): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
  }

  private static normalizeBoolean(value: unknown, fallback: boolean): boolean {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return fallback;
  }

  private static getAppApiClient() {
    return ApiClient.getClient(Api.AppApi) as AppApi;
  }

  private static getExpeditionApiClient() {
    return ApiClient.getClient(Api.ExpeditionApi) as ExpeditionApi;
  }

  static async getAdminShipments(pageNum: number = 1, pageSize: number = 50, hideAlreadyRead: boolean = false): Promise<PageableShipment> {
    const appApi = this.getAppApiClient();
    const safePageNum = this.normalizePositiveInt(pageNum, 1);
    const safePageSize = this.normalizePositiveInt(pageSize, 50);
    const safeHideAlreadyRead = this.normalizeBoolean(hideAlreadyRead, false);

    const requestParams: { pageNum: number; pageSize: number; hideAlreadyRead?: boolean } = {
      pageNum: safePageNum,
      pageSize: safePageSize,
      hideAlreadyRead: safeHideAlreadyRead,
    };

    const pageableShipments: PageableShipment = await appApi.getAdminExpeditionsRaw(requestParams as any).then((res) => res.value());

    return pageableShipments;
  }

  static async getStatusExpedition(shipmentExp: string, phoneNumber: string): Promise<ExpeditionStatusResponse> {
    const appApi = this.getAppApiClient();
    const expeditionStatusResponse = await appApi.getStatusExpedition(shipmentExp, phoneNumber);

    return expeditionStatusResponse;
  }

  static async getStatusExpeditionByReference(reference: number): Promise<ExpeditionStatusResponse> {
    const appExpedition = this.getExpeditionApiClient();
    const res: ExpeditionStatusResponse = await appExpedition.getStatusExpeditionByRef(reference);

    return res;
  }

  static async filterExpeditionsByLastMessage(pageNum: number = 1, pageSize: number = 50, hideAlreadyRead: boolean = false): Promise<PageableShipment> {
    const appApi = this.getAppApiClient();
    const response = await appApi.filterExpeditionsByLastMessage(pageNum, pageSize, hideAlreadyRead);

    return response;
  }
}
